export default class ZoomIn {
    constructor(selectorOfImages){
        this.imagesSelector = selectorOfImages;
        this.init();
    }

    init(){
        const imagesList = document.querySelectorAll(this.imagesSelector);

        imagesList.forEach(image => {
            const imgSrc = image.src;
            image.addEventListener('click', e => {
                this.imageOnClick(imgSrc);
            });
        })

        document.querySelector('#imgBox').addEventListener('click', e => {
           this.hideZoomImage();
        })

        document.addEventListener('scroll', e => {
            this.hideZoomImage();
        })
    }

    imageOnClick(srcImg){
        this.makeOverlayVisible();
        this.changeImageSrc(srcImg);
    }

    makeOverlayVisible() {
        document.querySelector('#imgBox').classList.add('showZoomBox')
    }

    changeImageSrc(src) {
        document.querySelector('#imageZoom').src = src
    }

    hideZoomImage(){
        document.querySelector('#imgBox').classList.remove('showZoomBox');
    }
}